class EmailSignup extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      button: '[js-email-button]'
    }
  }

  connectedCallback() {
    this.button = this.querySelector(this.selectors.button);
    this._setEventListeners();
  }

  _setEventListeners = () => {
    enquire.register(config.mediaQueries['desktop'],{
      match: function(){
        this.button.addEventListener('click', this._displayModalDesktop);
        this.button.removeEventListener('click', this._displayModalMobile);
      }.bind(this)
    })
  
    enquire.register(config.mediaQueries['belowDesktop'],{
      match: function(){
        this.button.removeEventListener('click', this._displayModalDesktop);
        this.button.addEventListener('click', this._displayModalMobile);
      }.bind(this)
    })
  }

  /*
  _displayModalDesktop = (evt) => {
    var desktopId = this.button.dataset.desktop;
    window.__attentive.trigger(null,null,null,desktopId)
  }

  _displayModalMobile = (evt) => {
    var mobileId = this.button.dataset.mobile;
    window.__attentive.trigger(null,null,null,mobileId)
  }
  */

  _displayModalDesktop = (evt) => {
    const desktopId = this.button?.dataset?.desktop;

    if (!window.__attentive || typeof window.__attentive.trigger !== 'function') {
      console.warn('[Attentive] __attentive.trigger not available', {
        hasAttentive: !!window.__attentive,
        attentiveKeys: window.__attentive ? Object.keys(window.__attentive) : null,
        desktopId
      });
      return;
    }

    window.__attentive.trigger(null, null, null, desktopId);
  }

  _displayModalMobile = (evt) => {
    const mobileId = this.button?.dataset?.mobile;

    if (!window.__attentive || typeof window.__attentive.trigger !== 'function') {
      console.warn('[Attentive] __attentive.trigger not available', {
        hasAttentive: !!window.__attentive,
        attentiveKeys: window.__attentive ? Object.keys(window.__attentive) : null,
        mobileId
      });
      return;
    }

    window.__attentive.trigger(null, null, null, mobileId);
  }

}

customElements.define("email-signup", EmailSignup);